import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../core/services/auth.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import { MessageModalComponent } from '../../shared/message-modal/message-modal.component';
import { isDevMode } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  form: FormGroup;
  private guestId;
  private devEmail;
  private destination;
  unauthorized = false;

  public showErrorButtons:boolean =false;

  constructor(
      private authService: AuthService,
      private http: Http,
      private fb: FormBuilder,
      private router: Router,
      private route: ActivatedRoute,
      private modal: NgbModal) {
  }

  ngOnInit() {

    if (this.authService.loggedIn()) {
      this.authService.logout2()
    }

    const url = '/api/errorlogger/testerror';
    this.http.get(url).toPromise().then(res => {
      switch (res.json()) {
        case 'dev':
          this.showErrorButtons = true;
          break;
        case 'int':
          this.showErrorButtons = true;
          break;
        case 'integration':
          this.showErrorButtons = true;
          break;
        default:
          this.showErrorButtons = false;
      }
    });


    this.guestId = this.route.snapshot.paramMap.get('guestId')
    this.devEmail = this.route.snapshot.queryParamMap.get('devEmail');
    this.destination = this.route.snapshot.queryParamMap.get('destination');

    if (!this.guestId) {
      this.guestId = localStorage.getItem('guestId')

      if (!this.guestId) {
        // Throw Error: Missing guest id.
        this.router.navigate(['/error'])
      }
    }

    const fields = {
      password: ['', Validators.required],
      guestId: [this.guestId]
    }

    if (this.devEmail !== null) {
      fields['devEmail'] = [this.devEmail];
    }

    if(this.destination.includes('onboarding')){
      fields['isVolunteer'] = this.destination.includes('volunteer-agreement');
      fields['isTCP'] = this.destination.includes('tcp');
      fields['isAuthorizedRep'] = this.destination.includes('authorized-rep');
    }

    this.form = this.fb.group(fields);


  }

  submit() {
    let is_vms = true;
    if (this.form.valid) {
      let url = '/api/ext_login/';
      if (this.router.url.indexOf("onboarding") > -1) {
        url = 'api/ext_login/onboarding';
        is_vms = false;
      }

      this.http.post(url, this.form.value)
        .toPromise()
        .then(res => {
          if (res) {
            if (is_vms) {
              this.authService.login(res.json());
            } else {
              this.authService.onboardingLogin(res.json());
            }
            this.unauthorized = false;

            // Onboarding routes
            if(is_vms == false) {
              if(this.destination.includes('tcp')){
                this.router.navigate(['onboarding', localStorage.getItem('requestId'), 'tcp'])
              } else if(this.destination.includes('volunteer-agreement')){
                this.router.navigate(['onboarding', localStorage.getItem('requestId'), 'volunteer-agreement'])
              } else if (this.destination.includes('authorized-rep')) {
                this.router.navigate(['onboarding', localStorage.getItem('requestId'), 'authorized-rep'])
              }
              else{
                //TODO, replace internal to go directly to person edit form
                this.router.navigate(['onboarding', localStorage.getItem('personId'), 'edit'])
              }
            } else {
              // VMS routes
              if (this.destination.includes('edit') && is_vms) {
                this.router.navigate(['request', 'overview']) // Temp till we update the email to be more descriptive.
              } else {
                window.location.replace(this.destination);
              }
            }

          } else {
            this.unauthorized = true;
            this.authService.logout2();
          }
        })
        .catch(err => {
         if (err.status === 404) {
           this.router.navigate(['cancelled']).then(res => { console.log});
         }
         else if (err.status === 422) {
            const modalRef = this.modal.open(MessageModalComponent, { backdrop: 'static' });
            modalRef.componentInstance.content = err._body;
            modalRef.componentInstance.title = 'Unauthorized'
         }
         
         else {
           this.unauthorized = true;
           this.authService.logout2();
         }
        });
    }
  }



  //NOTE: the following is for testing purposes. This code should be removed
  throwClientSideTestError(){
    throw new Error(
      "This is a test client-side test error happening on external side."
     );
  }

  throwServerSideTestError(){
    const url = '/api/errorlogger/testerror';
    this.http.post(url,"").toPromise().then(res=>res);
  }
  //*************************************************************************



}
